
import React,{useState,useContext} from 'react'

        export const AppContext = React.createContext();

export function Context({focusedState, testClick,targetForDrop,drop,applyChanges,dragging,setDragging,deleteControl,changeSectionLayout,showProperties, setShowProperties,formState2,setFormState,
    updateColumnWidth,handleReorderStart,handleReorderDrop,selected,setSelected,addColumn,device,setDevice,updateJson,children,subFormStateJson,
    showDataAdditionSection,setShowDataAdditionSection,draggedObjType,customControlIdList,setCustomControlIdList,
    handleCustomControlId, changeCanvasLayout,selectedControl,setSelectedControl,draggedFrom,setDraggedFrom, openDrawer, setOpenDrawer, 
    drawerPinned,setDrawerPinned, propertyPinned, setPropertyPinned, openProperties, setOpenProperties,showAlertConfirmNotifications, dataObjectJson, setDataObjectJson, 
    alertResponseMessage, setAlertResponseMessage, widthOfCanvasArea, setWidthOfCanvas,formState, updatedComponentInFormStatePreview, setSubFormState,
    openCanvasForSubform, templateForm, setFormTemplate , setCurrElem ,activePage , setActivePage, activeApplication,showPagesSubForms ,setShowPagesSubForms, 
    allPages, setAllPages, allSubForms, setSubForms, setFormState2, applicationScreenshot ,setApplicationScreenshot,setActiveApplication, dataObjects, setDataObjects, mappingDataObjectsMap, DataObjectsArray
,  handleValueForConditionalVisibility,toggleProperty, setToggleProperty,
valueForConditionalVisibility,openLoader, setOpenLoader }){      

const allContexts={
    clickFunc: (event)=>testClick(event),
    ping_onDragOver:(event)=>targetForDrop(event),
    ping_onDrop: (event)=>drop(event),
    applyChanges,
    // applyChanges:(arg1,arg2)=>applyChanges(arg1, arg2),
    focusedState,
    dragging,setDragging,
    deleteControl,
    changeSectionLayout,
    showProperties, 
    setShowProperties,
    formState2,
    setFormState,
    updateColumnWidth,
    handleReorderStart,
    handleReorderDrop,
    selected,setSelected,
    device,
    setDevice,
    addColumn,
    updateJson,
    showDataAdditionSection,
    setShowDataAdditionSection:(arg)=>setShowDataAdditionSection(arg),
    draggedObjType,
    customControlIdList,
    setCustomControlIdList:(arg)=>setCustomControlIdList(arg),
    handleCustomControlId:(arg1,arg2)=>handleCustomControlId(arg1, arg2),
    changeCanvasLayout,
    selectedControl,
    setSelectedControl,
    draggedFrom,
    setDraggedFrom,
    openDrawer,
    setOpenDrawer,
    widthOfCanvasArea,
    setWidthOfCanvas,
    drawerPinned,
    setDrawerPinned, 
    propertyPinned, 
    setPropertyPinned,
    openProperties, 
    setOpenProperties,
    showAlertConfirmNotifications:(arg)=>showAlertConfirmNotifications(arg),
    alertResponseMessage, 
    setAlertResponseMessage:(arg)=>setAlertResponseMessage(arg),
    formState,
    updatedComponentInFormStatePreview,
    setSubFormState,
    openCanvasForSubform,
    templateForm,
    setFormTemplate,
    activePage,
    setActivePage,
    activeApplication,
    showPagesSubForms ,
    setShowPagesSubForms,
    allPages,
    setAllPages,
    allSubForms,
    setSubForms,
    setFormState2,
    applicationScreenshot,
    setApplicationScreenshot,
    subFormStateJson,
    setCurrElem,
    setActiveApplication,
    handleValueForConditionalVisibility:(arg1,arg2)=>handleValueForConditionalVisibility(arg1, arg2),
    valueForConditionalVisibility,    
    dataObjectJson, 
    setDataObjectJson,
    dataObjects, 
    setDataObjects,
    mappingDataObjectsMap,
    DataObjectsArray,
    openLoader, setOpenLoader,
    toggleProperty, setToggleProperty,
}

    return (
        <AppContext.Provider value={allContexts}>      
                            {children}                        
        </AppContext.Provider>
    )
}

